import React from "react";
import {
  Flex,
  Icon,
  Menu,
  MenuItem,
  Type,
} from "@ebscois/react-component-library";

const ToolMenu = ({ tools, onToolClick }) => {
  // use currying to pass the tool in
  const handleMenuItemClick = (tool) => (evt) => {
    if (onToolClick) {
      onToolClick(evt, tool);
    }
  };

  return (
    <Menu
      triggerAnchor={{ vertical: "top", horizontal: "left" }}
      menuAnchor={{ vertical: "top", horizontal: "right" }}
      trigger={<Type fontSize="xs">Tools</Type>}
    >
      {tools?.map((tool) => (
        <MenuItem
          key={tool.action}
          onClick={handleMenuItemClick(tool)}
          data-testid={`${tool.testId}`}
        >
          <Flex container align={{ item: "center" }}>
            <Icon icon={{ glyph: tool.glyph, color: "gray600" }} />
            <Type paddingLeft="sm" fontSize="sm">
              {tool.hoverText}
            </Type>
          </Flex>
        </MenuItem>
      ))}
    </Menu>
  );
};

ToolMenu.displayName = "ToolMenu";

export default ToolMenu;
